import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function ShieldCheckIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M19.5 3.938h-15A1.313 1.313 0 0 0 3.188 5.25v5.51c0 8.272 7.001 11.018 8.404 11.483.265.09.551.09.816 0 1.406-.469 8.404-3.21 8.404-11.482V5.25A1.313 1.313 0 0 0 19.5 3.938m.188 6.824c0 7.5-6.36 9.993-7.635 10.415a.15.15 0 0 1-.105 0c-1.275-.423-7.635-2.915-7.635-10.415V5.25a.19.19 0 0 1 .187-.187h15a.19.19 0 0 1 .188.188zm-3.54-1.406a.563.563 0 0 1 0 .795l-5.25 5.25a.563.563 0 0 1-.795 0l-2.25-2.25a.563.563 0 0 1 .795-.795l1.852 1.848 4.853-4.852a.563.563 0 0 1 .795 0z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
